import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../PageTemplate/ListFormTemplate";
//import axios from 'axios';
import { config } from "../../utils/config";
import {
  fetchDataAndMapToField,
  waitForCookie,
} from "../../utils/helperFuctions";
import useCityLogic from "./useCityLogic";

const columns = [
  { field: "name", label: "Name", allowSorting: true },
  {
    field: "region",
    label: "Region",
    allowSorting: true,
    subvalue: "name",
    showInFilter: true,
  },
];

const CitiesPage = () => {
  const { addRoles, apiRoute, deleteRoles, editRoles, initFields, tabsData } =
    useCityLogic();
  const [fields, setfields] = useState(initFields);
  const loadOptions = async (branchId) => {
    try {
      const temp = [...initFields];

      //API endpoint to fetch the data
      const promises = [
        fetchDataAndMapToField(config, "cities/regions", "region", temp),
      ];

      // Wait for all promises to resolve
      await Promise.all(promises);

      setfields(temp);
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to Users" />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        tableNameInDb={"areas"}
        apiRoute={apiRoute}
        columns={columns}
        fields={fields}
        bringFormData={loadOptions}
        tabsData={tabsData}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
        enhancedTable={true}
      />
    </div>
  );
};

export default CitiesPage;
